import { render, staticRenderFns } from "./app-main.vue?vue&type=template&id=3cefca9c&scoped=true"
import script from "./app-main.vue?vue&type=script&lang=js"
export * from "./app-main.vue?vue&type=script&lang=js"
import style0 from "./app-main.vue?vue&type=style&index=0&id=3cefca9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cefca9c",
  null
  
)

export default component.exports